/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamQuestionLibraryItemExamitemid200,
  GetApiV1ExamQuestionLibraryItemExamitemid401,
  GetApiV1ExamQuestionLibraryItemExamitemid404,
  GetApiV1ExamQuestionLibraryItemExamitemid500,
  GetApiV1ExamQuestionLibraryItemExamitemidPathParams,
  GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibraryItemExamitemid.ts";
import { examItemDetailViewModelSchema } from "../examItemDetailViewModelSchema.ts";

export const getApiV1ExamQuestionLibraryItemExamitemidPathParamsSchema =
  z.object({
    examItemId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ExamQuestionLibraryItemExamitemidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamQuestionLibraryItemExamitemid200Schema = z.lazy(
  () => examItemDetailViewModelSchema,
) as unknown as ToZod<GetApiV1ExamQuestionLibraryItemExamitemid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamQuestionLibraryItemExamitemid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibraryItemExamitemid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamQuestionLibraryItemExamitemid404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibraryItemExamitemid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamQuestionLibraryItemExamitemid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibraryItemExamitemid500>;

export const getApiV1ExamQuestionLibraryItemExamitemidQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamQuestionLibraryItemExamitemid200Schema,
  ) as unknown as ToZod<GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse>;
